import axiosInstance from './axiosInstance';

const EmployeeService = {
    getEmployees: async (page = 0, size = 10) => {
        const response = await axiosInstance.get(`/api/employees?page=${page}&size=${size}&sort=lastName,asc`);
        return response.data;
    },

    getMe: async () => {
        const response = await axiosInstance.get('/api/employees/me');
        return response.data;
    },

    getMySalary: async () => {
        const response = await axiosInstance.get('/api/employees/me/salary');
        return response.data;
    },

    getEmployee: async (id) => {
        const response = await axiosInstance.get(`/api/employees/${id}`);
        return response.data;
    },

    createEmployee: async (data) => {
        const response = await axiosInstance.post('/api/employees', data);
        return response.data;
    },

    updateEmployee: async (id, data) => {
        const response = await axiosInstance.put(`/api/employees/${id}`, data);
        return response.data;
    },

    deleteEmployee: async (id) => {
        const response = await axiosInstance.delete(`/api/employees/${id}`);
        return response.data;
    },

    provisionAccount: async (id, email) => {
        const response = await axiosInstance.post(`/api/employees/${id}/provision-account`, { email });
        return response.data;
    },

    getSalaryHistory: async (id) => {
        const response = await axiosInstance.get(`/api/employees/${id}/salary`);
        return response.data;
    },

    addSalaryRecord: async (id, data) => {
        const response = await axiosInstance.post(`/api/employees/${id}/salary`, data);
        return response.data;
    },
};

export default EmployeeService;
